

export default umd;

import umdIntro from 'utils/umd/umdIntro';
import requireName from 'utils/umd/requireName';
import packageResult from 'utils/packageResult';
import getExportBlock from './utils/getExportBlock';
function umd(bundle, options) {
	requireName(options);

	var entry = bundle.entryModule;

	var intro = umdIntro({
		hasExports: entry.exports.length > 0,
		imports: bundle.externalModules,
		externalDefaults: bundle.externalModules.filter(needsDefault),
		amdName: options.amdName,
		name: options.name,
		indentStr: bundle.body.getIndentString(),
		strict: true,
		useStrict: options.useStrict !== false
	});

	if (entry.defaultExport) {
		bundle.body.append('\n\n' + getExportBlock(entry));
	}

	bundle.body.indent().prepend(intro).trimLines().append('\n\n}));');

	return packageResult(bundle, bundle.body, options, 'toUmd', true);
}

function needsDefault(externalModule) {
	return externalModule.needsDefault;
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/builders/strictMode/umd.js.01-babel.map